// extracted by mini-css-extract-plugin
module.exports = {"container":"victoryFeed_container__IvCoe","placeholder":"victoryFeed_placeholder__3hXPM"};